import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { EnvironmentService } from '../environment/environment.service';
import { HttpErrorHandlerService } from './http-error-handler.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private http: HttpClient,
    private env: EnvironmentService,
    private HttpErrorHandler: HttpErrorHandlerService,
    private AuthService: AuthService
  ) {}

  // Makes POST requests using GraphQL queries
  postGraphQL(data: any): Observable<any> {
    let url = this.env.api_url + '/graphql';

    return this.http
      .post<any>(url, data, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'X-CREAWeb-Agent': '89c5c30498c2989611f9044be006197c',
          Authorization: this.AuthService.getToken()
            ? this.AuthService.getToken()
            : '',
        }),
      })
      .pipe(
        tap(
          (result) => {
            if (result['errors']) {
              this.HttpErrorHandler.handleGraphQLError(result['errors']);
              return [];
            } else {
              return result['data'];
            }
          },
          (error) => {
            this.HttpErrorHandler.handleErrorOld('GraphQL', error);
          }
        )
      );
  }
}
